import {IntegrationBridgeType} from "platform/integration/bridge/IntegrationBridgeType";

export abstract class IntegrationBridge {

    public abstract sendMessage(message: string): void;

    public abstract type(): IntegrationBridgeType;
}
